export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मुद्रा"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रिपोर्ट बनाएं"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मुद्रा परिणाम"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["डाउनलोड"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पत्र"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्वीकृत फ़ाइल फॉर्मेट - xlsx"])}
}